import { $httpWithGateway } from "./common/request"

interface IData {
  [key: string]: string | number
}

interface IRequestConfig {
  [key: string]: string | number | boolean
}

interface IQueryOpenCardBenefitsData {
  activityId?: string
  outFromPage?: string
  source: 'APPLY_CARD' | 'SOURCE_CARD'
  clientSource: 'in' | 'out'
  // 是否外投广告进入：进度条文案灰度新逻辑使用
  fromAd?: boolean
}

/**
 * 权益集合查询
 */
export const queryMarketingBenefitSets = (
  data?: IData,
  config?: IRequestConfig
) =>
  $httpWithGateway(
    '/marketing/queryMarketingBenefitSets',
    data,
    config
  )

/**
 * mgm绑定接口
 */
export const getActivityBindings = (
  data?: IData,
  config?: IRequestConfig
) =>
  $httpWithGateway(
    '/marketing/joinActivity',
    data,
    config
  )

/**
 *
 * 获取权益资源位配置
 */
export const queryMarketActivityV2 = (
  data: IQueryOpenCardBenefitsData,
  config?: IRequestConfig
) =>
  $httpWithGateway(
    '/marketing/openCard/queryOpenCardBenefits',
    data,
    config
  )


/**
 * 获取用户全局最优返现信息
 */
export const queryGlobalBestActivity = (
  data: IData,
  config?: IRequestConfig
) =>
  $httpWithGateway(
    '/marketing/queryGlobalBestActivity',
    data,
    config
  )

/**
 * mgm 渠道 M2 落地页顶图文案信息
 */
export const queryMgmInfoForM2LandingPage = (
  data?: IData,
  config?: IRequestConfig
) =>
  $httpWithGateway(
    '/marketing/queryMgmInfoForM2LandingPage',
    data,
    config
  )
